<template>
    <div class="m-blockdetail">
        <h1 class="flex-left title">
            <i class="iconfont iconqukuaixiangqinglogo"></i>
            <span
                >{{ $t("blockDetail.title") }}&nbsp;&nbsp;{{
                    block.height
                }}</span
            >
        </h1>
        <p class="hash flex-left table-shadow">
            <span
                >{{ $t("block.hash") }}&nbsp;&nbsp;{{
                    block.hash | filterHash(20)
                }}</span
            >
            <i
                class="iconfont iconfuzhi"
                v-clipboard:copy="block.hash"
                v-clipboard:success="success"
                v-clipboard:error="error"
            ></i>
        </p>
        <block-info :infos="block"></block-info>
        <!-- 交易记录 -->
        <div class="tx-record table-shadow">
            <h2>{{ $t("blockDetail.record") }}</h2>
            <!-- 表格部分 -->
            <el-table
                :data="Trades"
                stripe
                style="width: 100%"
                class="data-table"
                :cell-class-name="groupCellName"
            >
                <template slot="empty">
                    <div>
                        <div
                            v-if="Loading"
                            class="loading-line"
                            v-loading="Loading"
                            element-loading-text="Loading..."
                            element-loading-spinner="el-icon-loading"
                        ></div>
                        <span v-else>{{ $t("page.nodata") }}</span>
                    </div>
                </template>
                <el-table-column label width="25">
                    <template slot-scope="item">
                        <div>
                            <div
                                :class="{
                                    'start-line': item.row.tradeG === 2,
                                    'middle-line': item.row.tradeG === 1,
                                    'end-line': item.row.tradeG === 3,
                                }"
                            >
                                <span v-if="item.row.tradeG !== 3"></span>
                                <i></i>
                                <span v-if="item.row.tradeG === 3"></span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('trade.hash')" width="160">
                    <template slot-scope="item">
                        <div>
                            <p class="group-title" v-if="item.row.tradeG === 2">
                                {{ $t("txDetail.groupTx") }}
                            </p>
                            <router-link
                                :to="`/tx/${item.row.txHash}`"
                                class="light flex-left"
                            >
                                <i
                                    class="iconfont err-ico"
                                    :class="{
                                        'iconjinggao-chucuo': isSuccess(
                                            item.row.tx.execer,
                                            item.row.receipt.ty
                                        ),
                                    }"
                                ></i>
                                {{ item.row.txHash | filterHash(10) }}
                            </router-link>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="hash"
                    :label="$t('home.sender')"
                    width="160"
                >
                    <template slot-scope="item">
                        <router-link
                            :to="`/address/${item.row.fromAddr}`"
                            class="light"
                            >{{
                                item.row.fromAddr | filterHash(10)
                            }}</router-link
                        >
                    </template>
                </el-table-column>
                <el-table-column width="50">
                    <template slot-scope="item">
                        <i class="iconfont iconjiantou-you"></i>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="hash"
                    :label="$t('home.receiver')"
                    width="160"
                >
                    <template slot-scope="item">
                        <router-link
                            :to="`/address/${item.row.tx.to}`"
                            class="light"
                            >{{ item.row.tx.to | filterHash(10) }}</router-link
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    prop="fee"
                    :label="$t('trade.num')"
                    width="160"
                >
                    <template slot-scope="item">{{
                        item.row | TradeValue
                    }}</template>
                </el-table-column>
                <el-table-column :label="$t('trade.fee')" width="120">
                    <template slot-scope="item"
                        >{{ item.row.fee
                        }}{{ item.row.tx.fee | filterFee }}</template
                    >
                </el-table-column>
                <el-table-column :label="$t('trade.func')" width="100">
                    <template slot-scope="item">{{
                        item.row.actionName === "unknown"
                            ? "none"
                            : item.row.actionName
                    }}</template>
                </el-table-column>
                <el-table-column :label="$t('trade.token')" width="80">
                    <template slot-scope="item">
                        <img :src="item.row.icon" class="token-icon" />
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 底部分页 -->
        <div class="bottom-page flex-right">
            <page-container
                @pageChange="pageChange"
                @sizeChange="sizeChange"
                :currentPage="pages.currentPage"
                :pageSize="pages.pageSize"
                :total="pages.total"
            ></page-container>
        </div>
    </div>
</template>

<script>
import BlockInfo from "./BlockInfos";
import PageContainer from "@/components/mobile/PageContainer.vue";
import BlockDetail from "@/mixins/BlockDetail/blockdetail.js";
import { tradeAccuracy } from "../../../utils/common";
export default {
    mixins: [BlockDetail],
    components: {
        BlockInfo,
        PageContainer,
    },
    methods: {
        isSuccess(execer, ty) {
            return tradeAccuracy(execer, ty);
        },
    },
};
</script>

<style lang="scss">
.m-blockdetail {
    padding: 10px 20px 17px;
    .title {
        .iconqukuaixiangqinglogo {
            color: $blue;
            font-size: 18px;
        }
        span {
            margin-left: 10px;
            color: $black;
            font-size: 14px;
            font-family: PingFangSC-Semibold;
            font-weight: 500;
        }
    }
    .hash {
        height: 37px;
        padding: 10px;
        margin-top: 15px;
        background: $white;
        color: $black;
        span {
            margin-left: 10px;
            // width: 200px;
            display: inline-block;
        }
        i {
            margin-left: 20px;
            color: $blue;
        }
    }
    .tx-record {
        .err-ico {
            color: #e45359;
            font-size: 12px;
            width: 13px;
            margin-right: 5px;
            display: inline-flex;
        }
        .data-table {
            font-size: 12px;
        }
        h2 {
            margin: 20px 0 10px;
            color: $black;
            font-size: 14px;
            font-family: PingFangSC-Semibold;
            font-weight: 500;
        }
        .el-table__header thead tr {
            height: 60px;
            color: $black;
        }
        .iconjiantou-you {
            font-size: 20px;
            color: #9aaab9;
        }
        .token-icon {
            height: 23px;
        }
        .tx-start,
        .tx-middle,
        .tx-end {
            background: $group_bg !important;
            .light,
            .iconjiantou-you {
                color: $group_title;
            }
        }
        .tx-start {
            padding-top: 45px;
        }
        .tx-start:nth-of-type(2) {
            padding-top: 0;
            // .cell {
            //   padding: 0;
            // }
        }
        .tx-start:nth-of-type(1),
        .tx-middle:nth-of-type(1),
        .tx-end:nth-of-type(1) {
            padding: 0;
            text-align: center;
            span {
                background: $group_title;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                display: block;
            }
            i {
                margin: 0 auto;
                display: block;
                width: 1px;
                background: $group_title;
            }
            .start-line {
                position: absolute;
                bottom: 0;
                width: 5px;
                span {
                    margin: 0 auto;
                }
                i {
                    height: 19.5px;
                }
            }
            .middle-line {
                width: 5px;
                span {
                    position: absolute;
                    top: 45%;
                }
                i {
                    height: 50px;
                }
            }
            .end-line {
                position: absolute;
                top: 0;
                width: 5px;
                span {
                    margin: 0 auto;
                }
                i {
                    height: 20.5px;
                }
            }
        }
        .group-title {
            margin: 15px 0 9px 20px;
            font-size: 14px;
            font-family: PingFangSC-Semibold;
            font-weight: 500;
            color: $group_title;
        }
    }
    .el-table td:nth-of-type(2) .cell {
        padding-left: 0;
    }
    .el-table th:nth-of-type(2) .cell {
        padding-left: 20px;
    }
    .bottom-page {
        margin-top: 20px;
    }
}
</style>
